import React, {Component} from 'react';
import axios from 'axios';
import {Alert, Card, Col, Row} from 'reactstrap';
import {Spinner} from "react-bootstrap";
import { connect } from 'react-redux';

class VerifyCreateUserComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: false,
            messageError: '',
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if ( typeof this.props.token !== 'undefined') {
            this.verifyCreateUser(this.props.token);
        }
        else {
            this.redirectError({
                error: 1,
                message: 'Kích hoạt tài khoản thất bại'
            });
        }
    }

    verifyCreateUser = (token) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.put( process.env.REACT_APP_API_URL + '/api/verifyCreateUser' , { token: token },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    this.redirect(ref.data);
                } else {
                    this.setState({
                        error: true,
                        isLoading: false,
                        messageError: ref.data.message,
                    })
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoading: false,
                    error: true,
                    messageError: 'Truy vấn đến Server thất bại',
                })
            })
    }

    redirect = async (item) => {
        await this.props.updateSuccessNotiUser(item);
        await this.props.redirect();
    }

    redirectError = async (item) => {
        await this.props.updateErrorNotiUser(item);
        await this.props.redirect();
    }

    render() {
        return (
            <>
                {
                    this.state.isLoading ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <Row
                            style={{
                                height: '100vh',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Col md={6} lg={4}>
                                <Card body>
                                    {
                                        this.state.error ? (

                                            <Alert color="danger">
                                                <div className='text-center'>
                                                    { this.state.messageError }
                                                </div>
                                            </Alert>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </Card>
                            </Col>
                        </Row>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = () => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(VerifyCreateUserComponent);